import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AccountState from '../../components/AccountState';

const PostpaidAccountInfo = ({
  contactData,
  creditLimit,
  banBalance,
  nrtbcBalance,
  debt,
  currency,
}) => {
  if (!creditLimit) {
    return null;
  }

  return (
    <AccountState
      banBalance={banBalance}
      nrtbcBalance={nrtbcBalance}
      debt={debt}
      currency={currency}
      {...contactData}
      {...creditLimit}
    />
  );
};

function mapStateToProps(state) {
  const balance = state.home.balance.data;

  return {
    contactData: (balance && balance.contactData) || {},
    creditLimit: balance && balance.creditLimit,
    banBalance: balance && balance.banBalance,
    nrtbcBalance: balance && balance.nrtbcBalance,
    debt: balance && balance.debt,
    currency: balance && balance.currency,
  };
}

PostpaidAccountInfo.propTypes = {
  contactData: PropTypes.object,
  creditLimit: PropTypes.object,
  banBalance: PropTypes.object,
  nrtbcBalance: PropTypes.object,
  debt: PropTypes.object,
  currency: PropTypes.string,
};

export default connect(mapStateToProps)(PostpaidAccountInfo);
